import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Table, Icon} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {monthAndYear} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import Models from './modelsDetail';
import PartLink from './partLink';

class LostSale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'viewModels': false,
      'viewReasons': false,
    };
    this.toggleModels = this.toggleModels.bind(this);
    this.toggleReasons = this.toggleReasons.bind(this);
    this.handlePartClick = this.handlePartClick.bind(this);
  }

  handlePartClick() {
    const {element} = this.props;
    this.props.getPartLostSalesDetail(element.partCode);
  }

  toggleModels() {
    const {viewModels, viewReasons} = this.state;

    this.setState({
      'viewModels': !viewModels,
      'viewReasons': !viewModels ? false : viewReasons,
    });
  }

  toggleReasons() {
    const {viewModels, viewReasons} = this.state;

    this.setState({
      'viewReasons': !viewReasons,
      'viewModels': !viewReasons ? false : viewModels,
    });
  }

  getIconName(flag) {
    return flag ? 'minus circle' : 'plus circle';
  }

  getProductionDate(date) {
    return date ? moment(date).format(monthAndYear).toUpperCase() : null;
  }

  renderExtraRow() {
    const {viewModels, viewReasons} = this.state;
    const {element} = this.props;

    if (viewModels) {
      return (
        <Models partCode={element.partCode} />
      );
    }

    if (viewReasons) {
      return (
        <Table.Row>
          <Table.Cell className='lost-sales-reasons' colSpan='100%'>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width='8' textAlign='center'>Motivo</Table.HeaderCell>
                  <Table.HeaderCell width='4' textAlign='center'>Cantidad</Table.HeaderCell>
                  <Table.HeaderCell width='4' textAlign='center'>Número de eventos</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {this.renderReasons()}
              </Table.Body>
            </Table>
          </Table.Cell>
        </Table.Row>
      );
    }

    return null;
  }

  renderReasons() {
    const {element} = this.props;

    return element.detail.map((lostSale, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='left'>{lostSale.reason}</Table.Cell>
          <Table.Cell textAlign='right'>{lostSale.quantity}</Table.Cell>
          <Table.Cell textAlign='right'>{lostSale.eventsCount}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderIndicators(element) {
    const {permissions} = this.props;

    if (hasAccessPermission(permissions, resources.DealerLostSalesReport, scopes.See)) {
      return (
        <React.Fragment>
          <Table.Cell textAlign='center'>{element.lostSalesIcc}</Table.Cell>
          <Table.Cell textAlign='right'>{element.lostSalesMad}</Table.Cell>
          <Table.Cell textAlign='right'>{element.lostSalesSoq}</Table.Cell>
        </React.Fragment>
      );
    }

    if (hasAccessPermission(permissions, resources.DealerLostSalesReport, scopes.PartialSee)) {
      return (
        <Table.Cell textAlign='center'>{element.lostSalesIcc}</Table.Cell>
      );
    }

    return null;
  }

  renderPrices(element) {
    const {permissions} = this.props;
    const completeSee = hasAccessPermission(permissions, resources.DealerLostSalesReport, scopes.See);
    const partialSee = hasAccessPermission(permissions, resources.DealerLostSalesReport, scopes.PartialSee);

    if (completeSee || partialSee) {
      return (
        <React.Fragment>
          <Table.Cell textAlign='right'>{'$'}{getNumericValue(element.wholesalePrice, 2)}</Table.Cell>
          <Table.Cell textAlign='right'>{'$'}{getNumericValue(element.totalWholesalePrice, 2)}</Table.Cell>
        </React.Fragment>
      );
    }

    return null;
  }

  render() {
    const {viewModels, viewReasons} = this.state;
    const {element} = this.props;

    return (
      <React.Fragment>
        <Table.Row>
          <Table.Cell textAlign='center'>
            <PartLink part={element.partCode} description={element.description} />
          </Table.Cell>
          <Table.Cell textAlign='left'>{element.description}</Table.Cell>
          <Table.Cell textAlign='center'>
            <Icon link size='large' className={this.getIconName(viewModels)} onClick={this.toggleModels} />
          </Table.Cell>
          {this.renderIndicators(element)}
          <Table.Cell textAlign='right'>{element.quantity || 0}</Table.Cell>
          <Table.Cell textAlign='right'>{'$'}{getNumericValue(element.price, 2)}</Table.Cell>
          <Table.Cell textAlign='right'>{'$'}{getNumericValue(element.totalPrice, 2)}</Table.Cell>
          {this.renderPrices(element)}
          <Table.Cell textAlign='right'>{this.getProductionDate(element.productionStart)}</Table.Cell>
          <Table.Cell textAlign='right'>{this.getProductionDate(element.productionEnd)}</Table.Cell>
          <Table.Cell textAlign='center'>{element.availability}</Table.Cell>
          <Table.Cell textAlign='center'>
            <Icon link size='large' className={this.getIconName(viewReasons)} onClick={this.toggleReasons} />
          </Table.Cell>
        </Table.Row>
        {this.renderExtraRow()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
  };
};

export default connect(mapStateToProps)(LostSale);
